import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { styled } from "@mui/material/styles";
import { SMALL_TABLET_SCREEN_SIZE } from "../../../AppNavigation/constants";
import { useTheme } from "@mui/material/styles";
import BrandClubButton from "../pagesComponents/BrandclubButton";

const Site = styled("div")(({ theme }) => ({
  "*": {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
  },
  "& .contact_content": {
    margin: "0 auto",
    maxWidth: 1082,
    width: "85.714286%",
    "&.contact_contact": {
      paddingTop: 100,
      paddingBottom: 100,
      display: "flex",
      flexDirection: "column",
      "& .contact_top": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& .contact_title": {
          fontWeight: "bold",
          width: 550,
          fontSize: 80,
          color: theme.vars.palette.text.primary,
          lineHeight: 1.13,
          textAlign: "center",
        },
      },
      "& .contact_bot": {
        marginTop: 92,
        display: "flex",
        justifyContent: "space-between",
        "& .contact_card": {
          maxWidth: "28%",
          borderRadius: 10,
          "& .contact_card_body": {
            margin: "-18px 18px 18px -18px",
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "85px 60px 60px 65px",
            "& .contact_title": {
              fontSize: 40,
              fontWeight: "bold",
              lineHeight: 1.28,
              textAlign: "center",
              marginBottom: 10,
              color: theme.vars.palette.text.primary,
            },
            "& .contact_desc": {
              fontSize: 20,
              fontWeight: 500,
              lineHeight: 1.27,
              textAlign: "center",
              color: theme.vars.palette.text.primary,
              height: 134,
            },
          },
        },
      },
    },
    "&.contact_form": {
      paddingTop: 150,
      paddingBottom: 300,
      display: "flex",
      flexDirection: "column",
      "& .contact_form_top": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& .contact_title": {
          fontWeight: "bold",
          marginBottom: 30,
          fontSize: 80,
          color: theme.vars.palette.text.primary,
          lineHeight: 1.13,
          textAlign: "center",
        },
        "& .contact_subtitle": {
          fontWeight: "bold",
          fontSize: 40,
          color: theme.vars.palette.text.primary,
          lineHeight: 1.13,
          textAlign: "center",
        },
      },
    },
  },
  "@media only screen and (max-width: 1279px)": {
    "& .contact_content": {
      "&.contact_contact": {
        paddingTop: 100,
        "& .contact_top": {
          "& .contact_title": {
            fontSize: 60,
          },
        },
        "& .contact_bot": {
          marginTop: 50,
          flexDirection: "column",
          alignItems: "center",
          paddingLeft: 20,
          "& .contact_card": {
            maxWidth: 339,
            margin: "50px 0",
            "& .contact_card_body": {
              padding: "78px 47px 75px 47px",
              "& .contact_title": {
                fontSize: 35,
              },
              "& .contact_desc": {
                lineHeight: 1.9,
              },
            },
          },
        },
      },
      "&.contact_form": {
        paddingTop: 120,
        "& .contact_form_top": {
          "& .contact_title": {
            fontSize: 48,
          },
          "& .contact_subtitle": {
            fontSize: 32,
          },
        },
      },
    },
  },
  [`@media only screen and (max-width: ${SMALL_TABLET_SCREEN_SIZE}px)`]: {
    "& .contact_content": {
      "&.contact_contact": {
        "& .contact_top": {
          "& .contact_title": {
            fontSize: 40,
          },
        },
        "& .contact_bot": {
          "& .contact_card": {
            maxWidth: "100%",
            width: "100%",
            "& .contact_card_body": {
              padding: "55px 40px 50px 35px",
              "& .contact_title": {
                fontSize: 30,
              },
              "& .contact_desc": {
                height: 94,
                lineHeight: 1.27,
              },
            },
          },
        },
      },
      "&.contact_form": {
        "& .contact_form_top": {
          "& .contact_title": {
            fontSize: 40,
          },
          "& .contact_subtitle": {
            fontSize: 26,
          },
        },
      },
    },
  },
  "@media only screen and (min-width: 1280px)": {
    "& .contact_content": {
      "&.contact_contact": {
        "& .contact_bot": {
          "& .contact_card": {
            width: 285,
            height: 331,
            maxWidth: 398,
            "& .contact_card_body": {
              padding: "50px 60px 45px 65px",
              height: 331,
              justifyContent: "center",
              "& .contact_title": {
                fontSize: 28,
              },
              "& .contact_desc": {
                fontSize: 16,
                height: 103,
                width: 200,
              },
            },
          },
        },
      },
      "&.contact_form": {
        "& .contact_form_top": {
          "& .contact_title": {
            fontSize: 60,
          },
          "& .contact_subtitle": {
            fontSize: 32,
          },
        },
      },
      "&.contact_supportform": {
        "& .contact_form_top": {
          "& .contact_title": {
            fontSize: 40,
          },
          "& .contact_subtitle": {
            fontSize: 20,
            fontWeight: 500,
          },
        },
      },
    },
  },
  "@media only screen and (min-width: 1750px)": {
    "& .contact_content": {
      maxWidth: 1369,
      "&.contact_contact": {
        "& .contact_bot": {
          "& .contact_card": {
            width: 398,
            height: 458,
            "& .contact_card_body": {
              padding: "70px 60px 60px 65px",
              height: 458,
              "& .contact_title": {
                fontSize: 40,
              },
              "& .contact_desc": {
                fontSize: 20,
                width: 250,
              },
            },
          },
        },
      },
      "&.contact_form": {
        "& .contact_form_top": {
          "& .contact_title": {
            fontSize: 80,
          },
          "& .contact_subtitle": {
            fontSize: 40,
          },
        },
      },
    },
  },
}));

interface ContactCardProps {
  title: string;
  desc: string;
  shapeColor?: string;
  backgroundColor: string;
  onClick: () => void;
}

const ContactCard = ({
  title,
  desc,
  backgroundColor,
  onClick,
  ...props
}: ContactCardProps) => {
  const theme = useTheme();
  const shapeColor = props.shapeColor || theme.vars.palette.primary.main;
  return (
    <div className="contact_card" style={{ backgroundColor: shapeColor }}>
      <div className="contact_card_body" style={{ backgroundColor }}>
        <div className="contact_title">{title}</div>
        <div className="contact_desc">{desc}</div>
        <BrandClubButton
          text="Contact us"
          shapeColor={shapeColor}
          onClick={onClick}
        />
      </div>
    </div>
  );
};

const ContactUs = () => {
  const navigate = useNavigate();

  return (
    <div className="contact_section contact_contact">
      <Helmet>
        <title>Contact</title>
        <meta
          name="description"
          content="Get in touch with our Brandclub support team."
        />
      </Helmet>
      <div className="contact_content_container">
        <div className="contact_content contact_contact">
          <div className="contact_top">
            <div className="contact_title">Contact us</div>
          </div>
          <div className="contact_bot">
            <ContactCard
              title="Business & Partnerships"
              desc="Are you interested in partnering with Brandclub?"
              shapeColor="#a21671"
              backgroundColor="#fdf0f5"
              onClick={() => navigate("/contact/business")}
            />
            <ContactCard
              title="Contact Support"
              desc="Have questions or need help with your Brandclub account?"
              backgroundColor="#e8f3fe"
              onClick={() => navigate("/contact/support")}
            />
            <ContactCard
              title="Media Relations"
              desc="Are you press and looking to do a story on Brandclub?"
              shapeColor="#16949b"
              backgroundColor="#eafbf5"
              onClick={() => navigate("/contact/media")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ContactPage = () => {
  return (
    <Site>
      <ContactUs />
    </Site>
  );
};

export default ContactPage;
